<template>
	<div class="login-dialog" v-if="showModal">
		<div class="main">
			<h1 class="cloumn">会员登录<span @click="closeChange"></span></h1>
			<div v-if="accountFlag" id="login_container">
				<wxlogin style="width: 300px; margin: 0 auto;" scope="snsapi_login" :appid="appid" :state="wxLoginState" :redirect_uri="redirectUri" :href="wxhref"></wxlogin>
				<p class="register"><span @click="accountChange">账号登录</span>还没有账号？<a href="">立即注册</a></p>
			</div>
			<div v-else>
				<div class="captcha-form" v-if="captchaVisible">
					<el-image :src="captchaImg" @click="captchaReload" fit="contain" alt="验证码" title="点击刷新" style="margin-bottom: 10px;cursor: pointer;" />
					<div style="text-align: left;padding: 0 60px;" v-if="errorCapVisible"><el-icon :size="16" color="#ff4c4f" style="vertical-align: text-top;margin: 2px 2px 0 0;"><Warning /></el-icon><el-text type="danger" style="font-size: 14px;">{{errorCaptcha}}</el-text></div>
					<el-input v-model="captchaAnswer" placeholder="请输入验证码" autocomplete="off" style="display: block;margin: 10px auto 24px;" />
					<el-button type="primary" @click="captchaClick(loginType)" style="font-size: 14px;">确定</el-button>
				</div>
				<div v-show="!captchaVisible">
					<el-form :rules="rulesMobile" ref="ruleMobileRef" :model="mobileForm" v-if="loginType == 'phone'">
						<div v-if="!multipleFlag">
							<el-form-item prop="mobile" class="mobile">
								<span class="ico">+86(中国大陆)</span>
								<el-input v-model="mobileForm.mobile" placeholder="手机号码" autocomplete="off" />
							</el-form-item>
							<el-form-item prop="code" class="code">
								<span class="ico"></span>
								<el-input v-model="mobileForm.code" placeholder="验证码" autocomplete="off" />
								<el-button type="primary" :disabled="codeSend" @click="codeChange" style="font-size: 14px;">{{codeSendText}}</el-button>
							</el-form-item>
							<div class="go-reg">
								<span @click="typeChange('account')">账号或邮箱登录</span>
								<p>还没有账号？立即&nbsp;<a href="https://www.landui.com/user/register">免费注册</a></p>
							</div>
						</div>
						<div class="check-account" v-else>
							<h4 class="title">请选择找回账号<span class="back" @click="backClick">&lt;返回</span></h4>
							<div class="li" v-for="(item, index) in multipleData" :key="index" @click="multipleChange(index,item.key)" :class="{ 'active': selectedMultiple === index }">{{item.name.username}}
								<div class="tags">
									<el-tag type="info" v-if="item.name.authstatus == 0">未认证</el-tag>
									<el-tag type="success" v-if="item.name.authstatus == 1">个人认证</el-tag>
									<el-tag type="success" v-if="item.name.authstatus == 2">企业认证</el-tag>
									<el-tag type="warning" v-if="item.name.prostatus == 1">保有产品</el-tag>
								</div>
							</div>
						</div>
						<el-form-item>
							<el-button type="primary" class="submit" :disabled="captchaVisible" @click="submitMobile(ruleMobileRef)">登录</el-button>
						</el-form-item>
					</el-form>
					<el-form :rules="rulesAccount" ref="ruleAccountRef" :model="accountForm" v-if="loginType == 'account'">
						<el-form-item prop="username" class="name">
							<span class="ico"></span>
							<el-input v-model="accountForm.username" placeholder="用户名/邮箱/手机号码" autocomplete="off" />
						</el-form-item>
						<el-form-item prop="password" class="pwd">
							<span class="ico"></span>
							<el-input v-model="accountForm.password" type="password" show-password placeholder="登录密码" autocomplete="off" />
						</el-form-item>
						<div class="go-reg">
							<span @click="typeChange('phone')">手机号码登录</span>
							<p>还没有账号？立即&nbsp;<a href="https://www.landui.com/user/register">免费注册</a></p>
						</div>
						<el-form-item>
							<el-button type="primary" class="submit" :disabled="captchaVisible" @click="submitAccount(ruleAccountRef)">登录</el-button>
						</el-form-item>
					</el-form>
					<div class="other" v-if="!multipleFlag">
						<div class="error-text" v-if="errorVisible"><el-icon :size="16" color="#ff4c4f" style="vertical-align: text-top;margin: 2px 2px 0 0;"><Warning /></el-icon><el-text type="danger" style="font-size: 14px;">{{errorText}}</el-text></div>
						<p>其他账户快捷登录：
							<span class="ico qq" @click="qqChange"></span>
							<span class="ico weixin" @click="wxChange"></span>
						</p>
						<a style=" float: right;color: #015bfe;" href="https://www.landui.com/index/user/repwd.html">忘记密码？</a>
					</div>
				</div>
			</div>
		</div>
	</div>
	
</template>

<script setup>
	import {ref,watch,reactive,onMounted} from "vue";
	import {useStore} from 'vuex'
	import wxlogin from "vue-wxlogin";
	import {captchaFetch,loginSendCode,accountcheck,loginAccount,loginMobile,getuserhasproduct,qqlogin,wechatlogin} from '@/api/home';
	import { ElMessage, ElMessageBox } from 'element-plus';
	import { Warning } from '@element-plus/icons-vue';
	
	const store = useStore()
	const errorVisible = ref(false)
	const errorText = ref('')
	const errorCapVisible = ref(false)
	const errorCaptcha = ref('')
	const accountFlag = ref(true)
	const multipleFlag = ref(false)
	const multipleData = ref();
	const selectedMultiple = ref();
	const token = ref('');
	const showModal = ref(false)
	const loginType = ref('phone');
	const codeSendText = ref('短信验证码');
	const codeSend = ref(false);
	const codeTime = ref(60);
	const captchaVisible = ref(false);
	const loginCaptcha = ref(false);
	const captchaAnswer = ref('');
	const captchaImg = ref('');
	const captchaId = ref('');
	const captchaBtn = ref('');
	const wxhref = ref('https://static.landui.com/statics/css/front/wxLogin.css');
	const appid = ref('');
	const redirectUri = ref('');
	const wxLoginState = ref('');
	const ruleAccountRef = ref(null);
	const accountForm = ref({username:'',password:''});
	const ruleMobileRef = ref(null);
	const mobileForm = ref({mobile:'',code:''});
	const rulesAccount = reactive({
		username: [
			{ required: true, message: '请填写登录账号', trigger: 'blur' },
		],
		password: [
			{ required: true, message: '请填写登录密码', trigger: 'blur' },
		]
	});
	const rulesMobile = reactive({
		mobile: [
			{ required: true, message: '请填写手机号码', trigger: 'blur' },
			{ min: 11, message: '请填写正确手机号格式', trigger: 'blur' }
		],
		code: [
			{ required: true, message: '请填写验证码', trigger: 'blur' },
		]
	});
	const props = defineProps({
	  show: {
	    type: Boolean,
	    default: false,
	  }
	});
	const emit = defineEmits(['loginClose', 'loginBuy']);
	watch(() => props.show,(newValue) => {
	    showModal.value = newValue;
	});
	
	const closeChange = () => {
		showModal.value = false;
		accountFlag.value = true;
		emit('loginClose', showModal.value);
	};
	const accountChange = () => {
		accountFlag.value = false;
	}
	const typeChange = (val) => {
		loginType.value = val;
		errorText.value = ''
		errorVisible.value = false;
		switch(val)
		{
			case 'account':
				ruleMobileRef.value.resetFields()
			break;
			case 'phone':
				ruleAccountRef.value.resetFields()
			break;
		}
	};
	const backClick = () => {
		mobileForm.value = {mobile:'',code:''};
		multipleFlag.value = !multipleFlag.value;
	}
	const captchaChange = () => {
		captchaFetch().then((res) => {
			if (res.code == 200) {
				captchaImg.value = res.data.captcha_data;
				captchaId.value = res.data.captcha_id;
			}
			if (res.code == 205) {
				errorVisible.value = true;
				errorText.value = res.msg
			}
		})
	}
	const codeChange = () => {
		ruleMobileRef.value.validateField('mobile',(valid) => {
			if(valid){
				captchaChange()
				captchaAnswer.value = '';
				captchaId.value = '';
				captchaBtn.value = '发送验证码';
				captchaVisible.value = !captchaVisible.value;
			}
		})
	}
	const captchaClick = (val) => {
		if (val == 'account') {
			captchaVisible.value = !captchaVisible.value;
			submitAccount()
		}
		if (val == 'phone') {
			const param = {
				'captcha_answer':captchaAnswer.value,
				'captcha_id':captchaId.value,
				'mobile':mobileForm.value.mobile,
			}
			loginSendCode(param).then((res) => {
				if (res.code == 200) {
					codeSend.value = true;
					codeSendText.value = codeTime.value+'s后重新发送';
					let timer = setInterval(() => {
					   codeTime.value--;
					   codeSendText.value = codeTime.value + 's后重新发送';
					   if (codeTime.value < 0) {
						   clearInterval(timer);
						   codeSendText.value = '获取验证码';
						   codeTime.value = 60;
						   codeSend.value = false
					   }
					}, 1000)
					captchaVisible.value = !captchaVisible.value;
					errorCapVisible.value = false;
					errorCaptcha.value = '';
				}
				if (res.code == 205) {
					errorCapVisible.value = true;
					errorCaptcha.value = res.msg;
					captchaChange()
					captchaAnswer.value = ''
				}
			})
		}
	}
	const multipleChange = (key,value) => {
		selectedMultiple.value = key;
		token.value = value;
	};
	const accountLogin = (param) => {
		loginAccount(param).then((res) => {
			if(res.code === 200){
				showModal.value = false;
				store.commit("setLogin", true)
				store.commit("setUserName", res.data.username)
				emit('loginBuy', true);
			}
			if (res.code == 205) {
				errorVisible.value = true;
				errorText.value = res.msg;
			}
		})
	}
	const submitAccount = () => {
		if (!ruleAccountRef.value) return;
		ruleAccountRef.value.validate((valid) => {
			if (valid) {
				const param = accountForm.value;
				if (loginCaptcha.value) {
					param['captcha_answer'] = captchaAnswer.value;
					param['captcha_id'] = captchaId.value;
				}
				if (captchaAnswer.value !== '') {
					accountLogin(param)
					captchaAnswer.value = '';
				}else{
					accountcheck({'username':accountForm.value.username}).then((res) => {
						if(res.code === 200){
						  if (res.data.is_captcha) {
							captchaChange()
							captchaAnswer.value = '';
							captchaBtn.value = '确定';
							captchaVisible.value = true;
							loginCaptcha.value = true;
						  }else{
							accountLogin(param)
						  }
						}
					})
				}
			} else {
			  return false;
			}
		});
	};
	const submitMobile = () => {
		if (!ruleMobileRef.value) return;
		ruleMobileRef.value.validate((valid) => {
			if (valid) {
				const param = mobileForm.value;
				if (multipleFlag.value) {
					param['way'] = 'token';
					param['code'] = token.value;
				} else{
					param['way'] = 'mobile'
				}
				loginMobile(param).then((res) => {
					if(res.code === 200){
						if (res.data.ischoose == '1') {
							const chooseData = res.data.unamelist;
							getuserhasproduct({'mobile':mobileForm.value.mobile}).then((data) => {
								if (data.code == 200) {
									const result = {};
									Object.keys(data.data).forEach(key => {
									  // 检查 obj2 是否包含相同的键
									  if (Object.prototype.hasOwnProperty.call(chooseData, key)) {
									    // 创建一个新的对象来存储合并后的数据
									    const newObj = {
									      ...chooseData[key], // 复制 obj2[key] 的所有属性
									      prostatus: data.data[key] // 添加 pro 属性
									    };
									    // 将新对象添加到结果对象中
									    result[key] = newObj;
									  }
									});
									const unamelist = result;
									const transformedData = [];
									for (const [key, name] of Object.entries(unamelist)) {
									    transformedData.push({
									        key: key,
									        name: name
									    });
									}
									multipleData.value = transformedData;
									multipleFlag.value = true;
								}
							})
						} else{
							showModal.value = false;
							store.commit("setLogin", true)
							store.commit("setUserName", res.data.username)
							emit('loginBuy', true);
						}
					}
					if (res.code == 205) {
						errorVisible.value = true;
						errorText.value = res.msg
					}
				})
			} else {
			  return false;
			}
		});
	};
	const qqChange = () => {
		qqlogin().then((res) => {
			window.location.href = res.data.qqLoginUrl; 
		})
	}
	const wxChange = () => {
		accountFlag.value = true;
		wechatLoginF()
	}
	const wechatLoginF = () => {
		wechatlogin().then((res) => {
			setCookie('landuiWxQxReUrl', window.location.href, 1, '.landui.com');
			if (res.code == 200) {
				appid.value = res.data.appid;
				redirectUri.value = res.data.redirect_uri;
				wxLoginState.value = res.data.state
			}
		})
	}
	const captchaReload = () => {
		captchaChange()
	}
	const setCookie = (name, value, days, domain) => {
		let expires = "";
		if (days) {
			const date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = "; expires=" + date.toUTCString();
		}
		const domainAttribute = domain ? "; domain=" + domain : "";
		document.cookie = name + "=" + (value || "") + expires + "; path=/" + domainAttribute;
	}
	
	onMounted(() => {
		wechatLoginF()
	});
</script>

<style lang="scss">
	.captcha-form{
		padding: 40px 30px 0;
		text-align: center;
		overflow: hidden;
		.el-input{width: 340px;}
		.el-input__wrapper{width: 100%;}
		.el-button{height: 36px;line-height: 36px; width: 110px; border-radius: 0;}
	}
	.error-info{height: 20px; overflow: hidden;}
	.error-text{ text-align: left; background-color: #fff; position: absolute; right: 30px; left: 84px; bottom: 202px;}
	.login-dialog{
		.el-form{
			background: #fff;
			padding: 30px 85px 0;
			.el-form-item{
				position: relative;
				margin-bottom: 15px;
				.el-input{
					font-size: 14px;
					width: 100% !important;
					--el-input-height:45px;
				}
				.el-input__wrapper{padding: 1px;border-radius:0 !important;padding-left: 40px !important;}
				.ico{
					position: absolute;
					left: 0;
					top: 0;
					bottom: 0;
					z-index: 1;
					font-size: 13px;
					padding-left: 43px;
					line-height: 44px;
				}
				.el-input__suffix{margin-right: 5px;}
			}
			.mobile{
				.el-input__inner{padding-left: 104px;}
				.ico{background: url(https://static.landui.com/statics/images/user/ico/tel.png) 16px center no-repeat; }
			}
			.name{
				.ico{background: url(https://static.landui.com/statics/images/user/ico/name.png) 16px center no-repeat; }
			}
			.pwd{
				.ico{background: url(https://static.landui.com/statics/images/user/ico/pwd.png) 16px center no-repeat; }
			}
			.code{
				.el-button{position: absolute;top: 7px; right: 8px; width: 110px; text-align: center;}
				.ico{background: url(../assets/images/code.png) 16px center no-repeat; }
			}
			.submit{
				width: 100%;
				height: 48px;
				line-height: 48px;
				font-size: 18px;
				background: #015bfe;
			}
			.submit.is-disabled{
				background:#ccc;
				border-color:#ccc;
			}
		}
	}
	#login_container .close {
	    width: 40px;
	    height: 40px;
	    position: absolute;
	    right: 0;
	    top: 0;
	    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MDhCQTI3ODI0OUIwMTFFQkE5MTE4QTMxRkQ1NzVBM0YiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MDhCQTI3ODE0OUIwMTFFQkE5MTE4QTMxRkQ1NzVBM0YiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OTAwQ0YxQ0I0NTg5MTFFQkE4QjdDOUY3MTY4ODJFRjUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OTAwQ0YxQ0M0NTg5MTFFQkE4QjdDOUY3MTY4ODJFRjUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5c+6/MAAAA8klEQVR42qzWTQrCMBAF4PisCw+iG3Hpz1LEs/SWKuLGulfQi3ShgjOQQilpOpPMwIMmpXwMYUJHZVk6qgllRnk629pRQDnBI1fKg7IyRs6UI2XP0Jyy8S/vRliDNPWD72Tb2mRsbYjw+gK/qDpYlYgFEecPyhlhvUgXysGiSAhKwQaRPkiDiZAYJMHEyBAUw1QIVyE46Aa7tdZOg0g66utMhWggrmlgr5Z+jMRhVA81EodRPdRInHj1DYKMiVdhyLlWNBhyrhUNhkxEjMEAEWEwQgYxGCIxbMHQ2BAJYfz8Lvx/14HyNULa2JLyonz+AgwA4cJezTJm8BYAAAAASUVORK5CYII=) center no-repeat;
	    background-size: 20px auto;
	    cursor: pointer;
	}
</style>